module.exports = __webpack_public_path__ + "static/media/appstore.9c646615.svg";